import React, { Component } from 'react';
import headerImg1 from "../../../../../styles/img/NewPackSelector/headerImg1.svg";
import headerImg2 from "../../../../../styles/img/NewPackSelector/headerImg2.svg";
import Card from './Card';

const PackDetailsHeader = ({ hasThreePack, packHeaderDetails, goToNextStep }) => {
  return (
    <div className="header-container">
      <div className={`headerImg-container ${hasThreePack ? "three-packs" : ""}`}>
        <img src={headerImg1} alt="" />
        <img src={headerImg2} alt="" />
      </div>
      {
        packHeaderDetails.map(pack => {
          if (pack && Object.keys(pack).length) return (
            <Card
              hasThreePack={hasThreePack}
              packDetails={pack}
              key={pack.id}
              goToNextStep={goToNextStep}
            />)
          return null
        })
      }
    </div>
  );
}

export default PackDetailsHeader;



// WEBPACK FOOTER //
// ./src/components/buy/table-checkouts/PackSelectorPage/Details/PackDetailsHeader.js